import {
  type AlertSeverity,
  type PropsWithOptionalTestID,
} from "@boi/components-core";
import {
  ErrorIcon,
  WarningIcon,
  SuccessIcon,
  InfoIcon,
} from "@boi/react-icons";

import * as S from "./InlineAlert.styled";
import { Typography } from "../Typography";

export type InlineAlertProps = PropsWithOptionalTestID & {
  severity: AlertSeverity;
  children: string;
  id?: string;
  withRole?: boolean;
};

function InlineAlert(props: InlineAlertProps) {
  const {
    severity,
    children,
    id,
    withRole = true,
    testID = "inline-alert",
  } = props;

  const alertIcon = {
    error: <ErrorIcon aria-hidden="true" />,
    warning: <WarningIcon aria-hidden="true" />,
    success: <SuccessIcon aria-hidden="true" />,
    info: <InfoIcon aria-hidden="true" />,
  };

  return (
    <S.Container
      id={id}
      role={withRole ? "alert" : undefined}
      $severity={severity}
      data-testid={testID}
    >
      <S.IconWrapper $severity={severity}>{alertIcon[severity]}</S.IconWrapper>
      <Typography color="inherit">{children}</Typography>
    </S.Container>
  );
}

export default InlineAlert;
